import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { fontText, fontTextHead, fontTitle, fullCenter, useMobile } from '../../../base'

export default function SubTitle({ title, subtitle, sx = {}, sxSubtitle = {}, sxTitle = {} }) {
    const mobile = useMobile();

    return (
        <Box sx={{
            width: '100%', ...fullCenter, flexDirection: 'column', py: '80px',
            ...(mobile && { px: '16px' }),
            ...sx
        }}>
            {title && <Typography component={'h2'} sx={{
                fontFamily: 'inter', fontWeight: 700, px: '16px',
                ...fontTitle,
                ...sxTitle
            }}>{title}</Typography>}
            {subtitle && <Typography sx={{
                fontFamily: 'inter', fontWeight: 400, mt: '16px', px: '16px', ...fontTextHead,
                ...sxSubtitle
            }}>{subtitle}</Typography>}
        </Box>
    )
}
